import { ReactNode } from "react";
import IBaseDTO from "src/Interfaces/baseDTO";
import IGroupersDTO from "src/Interfaces/groupersDTO";

export enum GroupersAudit{
  RESPONSABLE = "1",
  SECTOR = "2",
  PROCESS = "3",
  MANAGER = "4",
  STANDARD = "5",
  TYPE = "6"
}

export enum AuditType{
  INTERNAL = 1,
  EXTERNAL = 2,
}

export enum AuditSituation{
  OPENED = 1,
  IN_AUDIT = 2,
  FINISHED = 3
}

export enum AuditItemSituation{
  CONFORM = 1,
  NOT_CONFORM = 2,
  OPPORTUNITY_IMPROVEMENT = 3,
  OBSERVATION = 4
}

export interface IFiltersAudits {
  filter?: string,
  situation?: string,
  process?: string;
  type?: string;
  sector?: string;
  standard?: string;
  startDate?: Date | null;
  endDate?: Date | null;
  responsable?: string;
  tags: string | undefined;
  auditId?: string | null;
}

export interface IGrouperOfAudits{
  grouper: IGroupersAudits;
  filters: IFiltersAudits;
  groupersSelect: IGroupersSelectAudits;
  layoutList: "list" | "card";
  loadGroupers: Function;
}

export interface IListOfAudits{
  layoutList?: "card" | "list";
  data: IAudits[];
  filterListSituation?: AuditSituation;
  filterListType?: AuditType;
  onCallbackDelete?: Function;
  onCallbackUpdate?: (id: number) => void;
  loadGroupers: Function;
}

export interface IListAudits {
  data: IAudits[] ;
  options: (row: any) => ReactNode;
  filter?: (a: any, index?: number | undefined) => boolean;
  layout?: "table"
}

export interface ICardAudits {
  data: IAudits[];
  options: (row: any) => ReactNode;
  filter?: (a: any, index?: number) => boolean;
}

export interface IGroupersAudits extends IGroupersDTO<IGroupersAudits>{
  id: number;
  id2: number | null;
  id3: number | null;
  title: string;
  title2: string | null;
  title3: string | null;
  opened: number;
  inAudit: number;
  finished: number;
  internal: number;
  external: number;
  imageName: string;
  image: string;
}

export interface IGroupersSelectAudits{
  group: GroupersAudit;
}

export interface IAudits extends IBaseDTO{
  adb001Id: number;
  adb001Efa002Id: number;
  adb001Efa005Id2: number;
  adb001Efa005Nome2: string;
  adb001Efa005Imagem2: string;
  adb001Codigo: string;
  adb001Titulo: string;
  adb001Descricao: string;
  adb001Situacao: number;
  adb001Tipo: number;
  adb001Dtinicioplan: Date;
  adb001Dtfimplan: Date;
  fullTitle: string;
  adb001Ada001Descricao: string;
  adb001Taa001Descricao: string;
  adb001Taa005Descricao: string;
  type: string;
}

export interface IAuditSelect extends IAudits{
  adb001CodigoInterno: number;
  adb001Dtinireal: Date;
  adb001Dtfimreal: Date;
  adb001Efa005Id: number;
  adb001Efa005Nome: string;
  adb001Ada001Id: number;
  adb001Taa001Id: number;
  adb001Taa005Id: number;
  adb001Oca001Id: number;
  adb001Oca001Descricao: string;
  adb001Oca002Id: number;
  adb001Oca002Descricao: string;
  adb001Oca004Idnc: number;
  adb001Oca004DescricaoNC: string;
  adb001Oca004Idom: number;
  adb001Oca004DescricaoOM: string;
  adb001Oca004Idob: number;
  adb001Oca004DescricaoOB: string;
  adtbb002: IAuditors[];
  adtbb003: IParticipantsAudit[];
  adtbb004: IAuditItems[];
  adb001Tags: string | string[] | null;
}

export interface IAuditors{
  adb002Id: number;
  adb002Efa005Id: number;
  adb002Efa005Nome: string;
  adb002Adb001Id: number;
  adb002Nomeauditor: string;
}

export interface IParticipantsAudit{
  adb003Id: number;
  adb003Efa005Id: number;
  adb003Efa005Nome: string;
  adb003Adb001Id: number;
  adb003Nomeparticipante: string;
}

export interface IAuditItems extends IBaseDTO{
  adb004Id?: number;
  adb004Abd001Id?: number;
  adb004Codigo?: string;
  adb004Descricao?: string;
  adb004Ordem?: number;
  adb004Situacao?: number;
  adb004Comentario?: string;
  adb004Ocb001Id?: number;
  adtbb005?: any;
  files?: any;
}
